import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import BaseModal from '../../components/BaseModal';
import ButtonPrimary from '../../components/ui/ButtonPrimary';
import ButtonTransparent from '../../components/ui/ButtonTransparent';

import { updateUserStatus } from '../../store/actions';

import './index.css';

const DeleteEmployeeModal = (props) => {
  const submit = (e) => {
    e.preventDefault();
    props.updateUserStatus(props.employee.UUID, 'removed');
    props.onClose();
  }

  const body = (
    <div className="employee-info__body">
      <h2 className="employee-info__title modal__body-title">
        {'Delete ' + props.title}
      </h2>
      <p className="employee-info__caution">Are you sure that you want to permanently delete the selected employee?</p>
      <form className="employee-info__form form" onSubmit={submit}>
        <div className="employee-info__btn-group form__group">
          <ButtonPrimary 
            className="btn btn--primary" 
            name="Delete Employee" 
            onClick={submit} 
          />
          <ButtonTransparent 
            className="btn btn--transparent" 
            name="Cancel" 
            onClick={props.onClose} 
          />
        </div>
      </form>
    </div>
  );

  return (
    <BaseModal body={body} footer={null} onClose={props.onClose}/>
  );
}

export default connect(null, {updateUserStatus})(withRouter(DeleteEmployeeModal));